import React from 'react';

const ErrorDiv = ({ error, errorAlignEnd, classes = "" }) => (
  <p className={`text-red-500 text-xs italic first-letter:uppercase ${errorAlignEnd ? "text-end " : ""}${classes}`}>
    {error}
  </p>
);

export default ErrorDiv;
